export const services = [
  {
    id: "websites",
    title: "Business Websites",
    short: "Premium, fast, and SEO ready websites built to convert.",
    description:
      "Hand crafted multi section sites with content management, polished animations, and analytics. Built for speed, accessibility, and search visibility.",
    bullets: [
      "Custom design system",
      "Mobile, tablet, desktop ready",
      "Lightning fast performance",
      "On page SEO baseline",
    ],
    icon: "Globe",
  },
  {
    id: "ordering",
    title: "Online Ordering Systems",
    short: "Take orders online without the giant commission fees.",
    description:
      "Branded ordering flows for restaurants and cafés with menu builder, modifiers, pickup or delivery, and WhatsApp or email order routing.",
    bullets: [
      "Menu and modifiers",
      "Pickup or delivery",
      "WhatsApp order routing",
      "Order dashboard",
    ],
    icon: "ShoppingBag",
  },
  {
    id: "booking",
    title: "Booking & Appointments",
    short: "Let clients book in seconds, 24/7.",
    description:
      "Reservation and appointment systems with smart slot logic, reminders, and cancellation flow. Plug into Google Calendar or run standalone.",
    bullets: [
      "Smart availability",
      "Auto-confirmations",
      "Reminders and missed appointment alerts",
      "Calendar sync",
    ],
    icon: "CalendarCheck",
  },
  {
    id: "whatsapp",
    title: "WhatsApp Automation",
    short: "Automatic reply, route leads, and confirm bookings on WhatsApp.",
    description:
      "Custom WhatsApp flows for FAQs, reservations, order tracking, and re engagement. Connect to your CRM or sheet.",
    bullets: [
      "Smart automatic reply",
      "Order & booking confirmations",
      "Lead routing",
      "Broadcasts and re engagement",
    ],
    icon: "MessageCircle",
  },
  {
    id: "ai-agents",
    title: "AI Customer Support Agents",
    short: "24/7 AI agents trained on your business.",
    description:
      "Conversational agents trained on your menu, services, FAQs, and tone. Embed on web or WhatsApp. Hand off to humans when needed.",
    bullets: [
      "Trained on your data",
      "Web and WhatsApp deployable",
      "Human handoff",
      "Conversation analytics",
    ],
    icon: "Bot",
  },
  {
    id: "dashboards",
    title: "Business Dashboards",
    short: "See your business at a glance, in real time.",
    description:
      "Custom admin dashboards: orders, bookings, revenue, customer insights. Role based access for owners, staff, and managers.",
    bullets: [
      "Real time KPIs",
      "Role based access",
      "Exports & reports",
      "Mobile-friendly",
    ],
    icon: "LayoutDashboard",
  },
  {
    id: "smart-spaces",
    title: "Smart Home & Smart Office",
    short: "Voice, sensors, and automations that just work.",
    description:
      "Plan, install, and tune smart space setups: lighting, climate, access, and routines. Brand agnostic and reliable.",
    bullets: [
      "Lighting & climate",
      "Access control",
      "Voice assistants",
      "Custom routines",
    ],
    icon: "Cpu",
  },
  {
    id: "custom-it",
    title: "Custom IT Solutions",
    short: "Tailored systems for tricky business problems.",
    description:
      "Internal tools, integrations, automations, migrations, and consultation. If it's digital and it should work, we build it.",
    bullets: [
      "Internal tools",
      "Integrations and APIs",
      "Workflow automation",
      "Tech consultation",
    ],
    icon: "Wrench",
  },
];

export const niches = [
  {
    name: "Restaurants",
    blurb:
      "Online ordering, reservations, menu management, and WhatsApp automation that fills more tables.",
    icon: "UtensilsCrossed",
  },
  {
    name: "Cafés",
    blurb:
      "Loyalty programs, mobile ordering, and elegant brand sites that turn first timers into regulars.",
    icon: "Coffee",
  },
  {
    name: "Clinics",
    blurb:
      "Appointment booking, reminders, patient intake, and clean trustworthy sites that build confidence.",
    icon: "Stethoscope",
  },
];

export const whyChoose = [
  {
    title: "Built for local businesses",
    body: "We know small ops. No bloated SaaS, no jargon — just systems that pay for themselves.",
    icon: "Target",
  },
  {
    title: "Premium design, real engineering",
    body: "Designs that look like a brand you'd trust, with code that won't break in two months.",
    icon: "Sparkles",
  },
  {
    title: "AI where it earns its keep",
    body: "We use AI when it saves time or money — not as a sticker on the homepage.",
    icon: "Brain",
  },
  {
    title: "Fast delivery, clear pricing",
    body: "Most builds ship in days, not months. You see scope, price, and timeline upfront.",
    icon: "Zap",
  },
];
